$( function(){
  
  /*$('#custom_search .instrument_icon_block .item').each( function(){
    var devName = $(this).data('instrument').replace('inst_','');
    $(this).prepend('<p>'+devName+'</p>');
  });*/
    
  var devComposerSelect, devCountrySelect, devDurStart, devDurEnd, devshowUl, devshowUl2, devYearStart, devYearEnd, devExtendedTech, checkIncTrans, devPublisher, devDifficulty, devComposer, devCountry, devLiving, devDeceased, devHe, devShe, devThey, checkLiving, checkDeceased, checkHe, checkShe, checkThey, product, htmlArraysLength;
  var htmlArrays = [];
  var composerSelectTags = [];
  var countrySelectTags = [];
  
  var documentURL = document.URL;
  if( documentURL.indexOf('devSearchTerm') > 0 ){
    var devQuery = documentURL.split('devSearchTerm=');
    var devTagsQuery = devQuery[1].replace(/%20/g, 'xxx');
    var devTags = devTagsQuery.replace(/xxx/g, ' ');
    var devTags = devTags.split('+');
    console.log(devTags);
    getProducts( devTags );
  }
  if( $('.collection .page-title').text().toLowerCase().indexOf('instrumentation ') > -1 ){
    $("#devYear").ionRangeSlider({
      type: "double",
      grid: true,
      min: 1613,
      grid: true,
      max: 2019,
      step: 1,
      onFinish: function (data) {
        devApplyFilters();
      }
    });
    $(".devMinutesInput").ionRangeSlider({
      type: "double",
      grid: true,
      min: 0.5,
      grid: true,
      max: 32,
      step: 0.5,
      onFinish: function (data) {
        devApplyFilters();
      }
    });
  }
  
  $('.devFiltrz select').on('change', function(e){
    devApplyFilters();
  });
  $('.devFiltersCheckboxes input').on('click', function(e){
    devApplyFilters();
  });
  
  $('#devClear').on('click', function(e){
    e.preventDefault();
    $('.custom_reset').trigger('click');
  });
  
  $('#devSubmit').on('click', function(e){
    e.preventDefault();
    $('.btn-custom-submit').trigger('click');
  });
  

function devApplyFilters(){
  var filtersArray = [];

  devComposer     = $('.devComposerN').val().replace(/ /g,'');
  devCountry      = $('.devCountryN').val().replace(/ /g,'');
  devDifficulty   = $('.devDifficulty').val().replace(/ /g,'');
  devPublisher    = $('.devPublisher').val().replace(/ /g,'');
  devExtendedTech = $('.devExtTech').val().replace(/ /g,'');
  
  var devTemp     = $("#devYear").prop("value").split(';');
  devYearStart    = devTemp[0];
  devYearEnd      = devTemp[1];
  
  var devTemp2     = $("#devMinutesInput").prop("value").split(';');
  devDurStart    = devTemp2[0];
  devDurEnd      = devTemp2[1];
  
  checkLiving     = $('#checkbox-a').is(":checked");
  checkDeceased   = $('#checkbox-b').is(":checked");
  checkHe         = $('#checkbox-c').is(":checked");
  checkShe        = $('#checkbox-d').is(":checked");
  checkThey       = $('#checkbox-e').is(":checked");
  checkIncTrans   = $('#checkbox-e').is(":checked");

  if( devComposer != 'Name'){
    filtersArray.push(devComposer);
  }
  if( devCountry != 'Name'){
    filtersArray.push(devCountry);
  }
  if( devDifficulty != 'Name'){
    filtersArray.push(devDifficulty);
  }
  if( devPublisher != 'Name'){
    filtersArray.push(devPublisher);
  }
  if( devExtendedTech != 'Name'){
    filtersArray.push(devExtendedTech);
  }
  if( checkLiving ){
    filtersArray.push('ComposerAlive_Living');
  }
  if( checkDeceased ){
    filtersArray.push('omposerAlive_Deceased');
  }
  if( checkHe ){
    filtersArray.push('ComposerPronoun_He');
  }
  if( checkShe ){
    filtersArray.push('ComposerPronoun_She');
  }
  if( checkThey ){
    filtersArray.push('ComposerPronoun_They');
  }
  if( checkIncTrans ){
    filtersArray.push('TransArr_No');
  }

  $('#devProduct-loop ul').not(':first').each( function(){
    var i = 0; 
    var p = 0;
    var count = 0;
    var devTempYear, devTempMinutes;
    var arrayOfYear = [];
    var arrayOfdurations = [];
    var allTagsArray = $(this).attr('data-tagname').split(',');
    
    //---------Year filter---------------------------------------------------
    // if more than one year tag found then find min and max year range
    for(p=0; p<allTagsArray.length; p++ ){
      if( allTagsArray[p].indexOf('Year_') > -1 ){
        devTempYear = allTagsArray[p].split('_')[1];
        arrayOfYear.push( devTempYear );
      }
    }
    if( arrayOfYear.length >  0 ){
      var devmin = Math.min.apply(Math,arrayOfYear);
      var devmax = Math.max.apply(Math,arrayOfYear);
    } else {
      var devmin = 0;
      var devmax = 0;
    }
    var devOnlyYearStart = parseInt( $('.devOnlyYear .irs-min').text().replace(/ /g,'').replace(/"/g, ""));
    var devOnlyYearEnd = parseInt( $('.devOnlyYear .irs-max').text().replace(/ /g,'').replace(/"/g, ""));
    
    /* devmax and devmin is range of tagged years */
    /* devYearStart and devYearEnd is the year filters range */
    
    if( ( devmax >= devYearStart  &&  devmax <= devYearEnd ) || ( devmin >= devYearStart  &&  devmin <= devYearEnd ) || ( devmin == 0 && devmax == 0 ) || ( devOnlyYearStart == devYearStart && devOnlyYearEnd == devYearEnd ) ){
      devshowUl = true;
    } else {
	  devshowUl = false;
    }
    //---------Year filter ends here--------------------------------------------
    
    //---------Minutes filter---------------------------------------------------
    for(p=0; p<allTagsArray.length; p++ ){
      if( allTagsArray[p].indexOf('duration_') > -1  ){
        devTempMinutes = allTagsArray[p].split('duration_')[1];
        arrayOfdurations.push( devTempMinutes );
      }
    }
    if( arrayOfdurations.length >  0 ){
      var devmin = Math.min.apply(Math,arrayOfdurations);
      var devmax = Math.max.apply(Math,arrayOfdurations);
    } else {
      var devmin = 0;
      var devmax = 0;
    }
    console.log(devmin);
    console.log(devmax);
    var devOnlyDurStart = parseFloat( $('.devMinutes .irs-min').text().replace(/ /g,'').replace(/"/g, ""));
    var devOnlyDurEnd   = parseFloat( $('.devMinutes .irs-max').text().replace(/ /g,'').replace(/"/g, ""));
    
    /* devmax and devmin is range of tagged duration */
    /* devDurStart and devDurEnd is the year filters range */
    
    if( ( devmax >= devDurStart  &&  devmax <= devDurEnd ) || ( devmin >= devDurStart  &&  devmin <= devDurEnd ) || ( devOnlyDurStart == devDurStart && devOnlyDurEnd == devDurEnd ) ){
      devshowUl2 = true;
    } else {
	  devshowUl2 = false;
    }
    //---------Minutes filter ends here-----------------------------------------

    for( i=0; i<filtersArray.length; i++ ){
      if( $(this).attr('data-tagname').indexOf( filtersArray[i] ) > -1 ){
        count++;
      }
    }
    if(count == filtersArray.length && devshowUl == true && devshowUl2 == true  ){
      $(this).show();
    } else {
      $(this).hide();
    }
  });

}
/*--------------------------------------------------------------------------Filter ends here-----------------------------------------------------------------------*/

function arrayContainsArray (superset, subset) {
  return subset.every(function (value) {
    return (superset.indexOf(value) >= 0);
  });
}

function getProducts( dTags ){
    $.ajax({
        type: 'GET',
        url: '/collections/instrumentation-search.json',
        dataType: 'json',
        success: function(ColResult){
          
          var forLimit = ColResult.collection.products_count;
          forLimit = parseInt( forLimit/30 + 1 );
          var j=0;
          var k=0;
          var lastLoopEle = 'otherThanFirst';
          
          //for( j=0; j<dTags.length; j++){
            var pagnum=1;
            for( k=0; k<forLimit; k++){
              if(forLimit-1 == k){
                var lastLoopEle = 'last';
                setTimeout(function(){
                  getFilterProducts(pagnum, dTags, lastLoopEle );
                }, 700);
              } else {
                getFilterProducts(pagnum, dTags, lastLoopEle );
              }
              
              pagnum++;
            }
          //}
         },
        error: function(status){
             console.log(status);
        }
    });
}




function getFilterProducts(pageNumber, dTags, lastLoopEle){
  
    $.ajax({
        type: 'GET',
        url: "/collections/instrumentation-search/products.json?page=" + pageNumber,
        dataType: 'json',
        success: function(res){
        	filterProducts(res.products, dTags, lastLoopEle ); 
        },
        error: function(status){
            console.log(status);
        }
    });
}




function filterProducts(products, dTags, lastLoopEle) {
  	
    var filteredProducts = products.filter(function(product){
      
      if(arrayContainsArray( product.tags, dTags)){
        return product.tags.indexOf(dTags[0]) > -1;
      }
      
    });
  
    if( filteredProducts.length > 0 ){
      var tagNames ='';
      var devHtml ='';
      var devComposer='';
      var devComLastName='';
      var devInstrumentationTemp = [];
      var devInstrumentation='';
      var devDuration='';
      var movement01='';
      var movement02='';
      var movement03='';
      var movement04='';
      var movement05='';
      var movement06='';
      var movement07='';
      var devPublisher='';
      var currentTag;
      var cartForm = '';
      var additionalTitle='';
      var dummyProduct = false;
      var i = 0;
      var devPrice;
      var orchestral = ["Piccolo","Flute","Alto Flute","Bass Flute","Recorder","Oboe","Oboe d'Amore","English Horn","Bass Oboe","A-Flat Clarinet","E-Flat Clarinet","D Clarinet","C Clarinet","B-Flat Clarinet","A Clarinet","Basset Clarinet","Basset,Horn","Alto Clarinet","Bass Clarinet","Contralto Clarinet","Contrabass Clarinet","Soprano Saxophone","Alto Saxophone","Tenor Saxophone","Baritone Saxophone","Bassoon","Contrabassoon","Piccolo Trumpet","Cornet","Trumpet","Flugelhorn","Horn","Trombone","Bass Trombone","Euphonium","Baritone","Tuba","Violin","Viola","Cello","Double Bass","Harp","Guitar","Electric Guitar","Electric Bass","High Voice","Low Voice","Piano","Organ","Accordion","Harpsichord","Percussion","Snare Drum","Marimba","Vibraphone","Orchestra","String Orchestra","Wind Ensemble","CD/Tape","Narrator"];
      
      for(i=0; i<filteredProducts.length; i++){
        
        
        devPrice = Shopify.formatMoney(filteredProducts[i].variants[0].price);
        dummyProduct = false;
        devDuration='';
        devInstrumentation='';
        devInstrumentationTemp = [];
        additionalTitle='';
        movement01='';
        movement02='';
        movement03='';
        movement04='';
        movement05='';
        movement06='';
        movement07='';
        tagNames='';
        devComposerSelect='';
        var removedSpaceTag= '';
        
        for( s=0; s<filteredProducts[i].tags.length; s++){
          
          //tagNames          = tagNames + ',' + filteredProducts[i].tags[s].replace(/"/g, "");
          tagNames          = tagNames + ',' + filteredProducts[i].tags[s];
          currentTag        = filteredProducts[i].tags[s].toLowerCase();
          removedSpaceTag   = filteredProducts[i].tags[s].replace(/ /g,'').replace(/"/g, "");
          
          if( currentTag.indexOf('fullname_') >= 0 ){
            devComposer       = currentTag.replace('composerfullname_','').split('~');
            devComposerSelect = removedSpaceTag.replace('ComposerFullName_','').split('~');
            
            if(devComposer.length > 1 ){
              	devComLastName    = currentTag.replace('composerfullname_','').split('~')[0];
            	devComposer = devComposer[1] + " " + devComposer[0];
              	var tempOption = '<option data-proName="' +  devComLastName + '" value="'+ removedSpaceTag +'">'+ devComposerSelect[1] + " " + devComposerSelect[0] +'</option>';
                if( !( $.inArray(tempOption, composerSelectTags) > -1) ){
                  composerSelectTags.push(tempOption);                
                }
            } else {
              	devComLastName    = currentTag.replace('composerfullname_','').split('~')[0];
                devComposer = devComposer[0];
              	var tempOption = '<option data-proName="' +  devComLastName + '"  value="'+ removedSpaceTag +'">'+ devComposerSelect[0] +'</option>';
                if( !( $.inArray(tempOption, composerSelectTags) > -1) ){
                  composerSelectTags.push(tempOption);                
                }
            }
          }
          
          
          if( currentTag.indexOf('composercountry_') >= 0 ){
            devCountrySelect = removedSpaceTag.replace('ComposerCountry_','');
            var tempOption = '<option data-proName="' +  devComLastName + '"  value="'+ removedSpaceTag +'">'+ devCountrySelect +'</option>';
            if( !( $.inArray(tempOption, countrySelectTags) > -1) ){
              countrySelectTags.push(tempOption);                
            }
          }
          
          
          if( currentTag.indexOf('instrument_') >= 0 ){
            devInstrumentationTemp.push( currentTag.replace('instrument_','').replace('_',' ') );            
          }
          
          if( currentTag.indexOf('durationwhole_') >= 0 ){
            devDuration = currentTag.replace('durationwhole_','').replace('&',', ');
          }
          
          if( currentTag.indexOf('publisher_') >= 0 ){
            devPublisher = currentTag.replace('publisher_','')/*.replace('&',', ')*/;
          }
          if( currentTag.indexOf('alternativetitle_') >= 0 ){
            additionalTitle = currentTag.replace('alternativetitle_','').replace(' ~',', ');
          }
          if( currentTag.indexOf('movement01_duration') >= 0 ){
            movement01 = currentTag.replace('movement01_duration_','').replace('&',', ').replace('~',',');
          }
          if( currentTag.indexOf('movement02_duration') >= 0 ){
            if( movement01.length > 0 ){
            	movement02 = "+" + currentTag.replace('movement02_duration_','').replace('&',', ').replace('~',',');
            } else {
              	movement02 = currentTag.replace('movement02_duration_','').replace('&',', ').replace('~',',');
            }
          }
          if( currentTag.indexOf('movement03_duration') >= 0 ){
            if( movement01.length > 0 || movement02.length > 0 ){
              	movement03 = "+" + currentTag.replace('movement03_duration_','').replace('&',', ').replace('~',',') + "<br>";
            } else {
              	movement03 = currentTag.replace('movement03_duration_','').replace('&',', ').replace('~',',');
            }
          }
          if( currentTag.indexOf('movement04_duration') >= 0 ){
            if( movement01.length > 0 || movement02.length > 0 || movement03.length > 0 ){
              movement04 = "+" + currentTag.replace('movement04_duration_','').replace('&',', ').replace('~',',');
            } else {
              movement04 = currentTag.replace('movement04_duration_','').replace('&',', ').replace('~',',');
            }
          }
          if( currentTag.indexOf('movement05_duration') > 0 ){
            if( movement01.length > 0 || movement02.length > 0 || movement03.length > 0 || movement04.length > 0 ){
              movement05 = "+" + currentTag.replace('movement05_duration_','').replace('&',', ').replace('~',',');
            } else {
              movement05 = currentTag.replace('movement05_duration_','').replace('&',', ').replace('~',',');
            }
          }
          if( currentTag.indexOf('movement06_duration') >= 0 ){
            if( movement01.length > 0 || movement02.length > 0 || movement03.length > 0 || movement04.length > 0 || movement05.length > 0 ){
              movement06 = "+" + currentTag.replace('movement06_duration_','').replace('&',', ').replace('~',',')+ "<br>";
            } else {
              movement06 = currentTag.replace('movement06_duration_','').replace('&',', ').replace('~',',');
            }
          }
          if( currentTag.indexOf('movement07_duration') >= 0 ){
            if( movement01.length > 0 || movement02.length > 0 || movement03.length > 0 || movement04.length > 0 || movement05.length > 0 || movement06.length > 0 ){
              movement07 = "+" + currentTag.replace('movement07_duration_','').replace('&',', ').replace('~',',');
            } else {
              movement07 = currentTag.replace('movement05_duration_','').replace('&',', ').replace('~',',');
            }
          }
          
          if( currentTag.indexOf('dummy_yes') >= 0 ){
            dummyProduct = true;
          }
        }
        
        if(dummyProduct == true){
          devPrice = '';
          /*devDuration = '';
          movement01 = '';
          movement02 = '';
          movement03 = '';
          movement04 = '';*/
          cartForm = '<a class="devMoreInfo" href="/products/' + filteredProducts[i].handle + '">More Info</a>';
        } else {
          cartForm = '<form method="post" action="/cart/add"><input type="hidden" name="id" value="' + filteredProducts[i].variants[0].id + '" /><input min="1" type="hidden" id="quantity" name="quantity" value="1"/><input type="submit" value="Add to cart" class="devListCart" /></form>';
        }
                
        tagNames = tagNames.replace(/ /g,'');
        tagNames = tagNames.replace(/"/g, "");
                
        var xx,y,z;
        for(y=0; y<orchestral.length;y++){
          for(z=0; z<devInstrumentationTemp.length;z++){
			xx = orchestral[y].toLowerCase();
            if(devInstrumentationTemp[z].toLowerCase().indexOf(xx) >= 0 ){
              if(devInstrumentation.length > 0){
                devInstrumentation = devInstrumentation + ", " +devInstrumentationTemp[z];
              } else {
                devInstrumentation = devInstrumentationTemp[z];
              }
            }          }
        }
        
        
        htmlArrays.push("<ul data-proName='"+ devComLastName +"' data-tagName='"+ tagNames +"'><li class='devCompo'>"+ devComposer +"</li><li class='devTitle'><a href='/products/"+ filteredProducts[i].handle +"'>"+ filteredProducts[i].title.split('_')[1] + "</a><br><span>" + additionalTitle + "</span></li><li class='devInstr'>"+ devInstrumentation +"</li><li class='devDurat'>"+ devDuration +"<br><span>"+ movement01 +""+ movement02 +""+ movement03 +""+ movement04 +""+ movement05 +""+ movement06 +""+ movement07 + "</span></li><li class='devPubli'>"+ devPublisher +"</li><li class='devPrice'>"+ devPrice + cartForm + "</li></ul>" );
        
      }
    }

  if(lastLoopEle == 'last'){
    var q;
    
    composerSelectTags.sort();
    countrySelectTags.sort();
    
    for( q=0; q<composerSelectTags.length;q++ ){
    	$('.devComposerN').append( composerSelectTags[q] );
    }
    for( q=0; q<countrySelectTags.length;q++ ){
    	$('.devCountryN').append( countrySelectTags[q] );
    }
    
    
    htmlArrays.sort();
    
      for( product=0; product<htmlArrays.length;product++){
        
          $('#devProduct-loop').append( htmlArrays[product] );
        
          setTimeout(function(){
            console.log( '' );
          }, 100);
      }
  }
}
  function devEqualHeights(){
    $('.devProduct-loop ul').each( function(){
      var devHeight = 0;
      $(this).find('li').each( function(){
        if( $(this).height() > devHeight ){
          devHeight = $(this).height();
        }
      });
      $(this).find('li').height(devHeight);
    });
  }
  
  function devEqualHeightsListen(){

    $('.devOnlyMobile ul').each( function(){
      var devHeight = 0;
      $(this).find('li').each( function(){
        if( $(this).height() > devHeight ){
          devHeight = $(this).height();
        }
      });
      $(this).find('li').height(devHeight);
    });
    
  }
  
  if( $(window).width() < 768 ){
  	devEqualHeights();
    //devEqualHeightsListen();
  }
  
  $(window).resize( function(){
    if( $(window).width() < 768 ){
      devEqualHeights();
      //devEqualHeightsListen();
    }
  });
  
  
});